import { useScimConfigurationQuery } from '../../security/queries/useScimConfigurationQuery';

export const useDisplaySourceColumn = () => {
    const { data } = useScimConfigurationQuery({ retry: false, disableDefaultErrorHandler: true });

    // We only want to hide the column if the SCIM configuration is undefined (we show it if its disabled + enabled)
    return !!data;
};
